import React from 'react';

type Props = {
  title: string;
  primaryColor?: string;
  pdf?: boolean;
  small?: boolean;
};

const ReportPrintHeader: React.FC<Props> = ({ title, primaryColor, pdf, small }) => {
  return pdf ? (
    <div className="relative">
      <div
        className="absolute flex items-center"
        aria-hidden="true"
        style={{
          top: 17,
          left: 0,
          right: 0,
        }}
      >
        <div
          className="w-full opacity-50"
          style={{
            borderTop: `2px solid ${primaryColor}`,
          }}
        />
      </div>
      <div className="relative flex justify-center">
        <span
          className={[
            'px-3 bg-white uppercase text-gray-800 font-semibold',
            small ? 'text-sm' : 'text-lg',
          ].join(' ')}
        >
          {title}
        </span>
      </div>
    </div>
  ) : (
    <div className="relative mb-4 mt-6">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div
          className="w-full opacity-50"
          style={{
            borderTop: `2px solid ${primaryColor}`,
          }}
        />
      </div>
      <div className="relative flex justify-center">
        <span
          className={[
            'px-3 bg-white uppercase text-gray-800 font-semibold',
            small ? 'text-sm' : 'text-lg',
          ].join(' ')}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

export default ReportPrintHeader;
